import { Avatar, Badge, Dropdown, Modal, Space } from "antd";

import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  GlobalOutlined,
  LockOutlined,
  LoginOutlined,
  UserOutlined,
} from "@ant-design/icons";

import EN from "components/elements/LanguageSwitcher/EN.json";
import TH from "components/elements/LanguageSwitcher/TH.json";

import session from "utils/session";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { ReactComponent as UserIcon } from "../../../assets/icon/userIcon.svg";
import { deleteToken } from "firebase/messaging";
// import useFirebaseNoti from "lib/useFirebaseNoti";

require("i18n/dayjs/en");
require("i18n/dayjs/th");

const User = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  // const { DeleteTokenWhenLogout } = useFirebaseNoti()
  const currentEmployee = useSelector((state) => state.company.currentEmployee);
  const { currentEmploymentHome } = useSelector((state) => state.employee);

  // const handleChange = useCallback((lng) => {
  //   window.localStorage.setItem("lang", lng);
  //   i18n.changeLanguage(lng);
  //   dayjs.locale(lng);
  // }, []);

  const getInfo = useMemo(() => {
    return { employeeImage: currentEmploymentHome?.employeeImage }
  }, [currentEmploymentHome])

  function createImageUrl(base64Data, contentType) {
    return `data:${contentType};base64,${base64Data}`;
  }

  const userAvatar = useCallback(
    () => {
      if (getInfo.employeeImage) {
        const imageUrl = createImageUrl(getInfo.employeeImage, "image/png");
        return imageUrl;
      } else {
        return <UserIcon />
      }
    },
    [getInfo.employeeImage],
  )

  const odSignOut = (e) => {
    e.preventDefault();
    Modal.confirm({
      title: t('logout.Areyousure'),
      content: (
        <>
          <p>{t('logout.are-you-sure-logout')}</p>
        </>
      ),
      onOk() {
        session.removeAuthToken();
        // DeleteTokenWhenLogout?.()
        navigate("/login");
      },
      okText: t('logout.confirm'),
      cancelText: t('logout.cancel'),
    });
  };

  return (
    <Dropdown
      menu={{
        items: [
          {
            key: "1",
            label: <a href={`/profile/${currentEmployee}`}>{t("employee.label.profile")}</a>,
            icon: <UserOutlined />,
          },
          // {
          //   key: "2",
          //   label: "Language",
          //   icon: <GlobalOutlined />,
          //   children: [
          //     {
          //       key: "2.english",
          //       label: (
          //         <Space onClick={() => handleChange("en")}>
          //           <img
          //             src={`data:image/png;base64, ${EN}`}
          //             alt="en"
          //             aria-label="en"
          //             width={40}
          //             height="auto"
          //           />
          //           ENGLISH
          //         </Space>
          //       ),
          //     },
          //     {
          //       key: "2.thai",
          //       label: (
          //         <Space onClick={() => handleChange("th")}>
          //           <img
          //             src={`data:image/png;base64, ${TH}`}
          //             alt="th"
          //             aria-label="th"
          //             width={40}
          //             height="auto"
          //           />
          //           ภาษาไทย
          //         </Space>
          //       ),
          //     },
          //   ],
          // },
          {
            key: "2",
            label: <a href="/change_password">{t("change_password.header")}</a>,
            icon: <LockOutlined />,
          },
          {
            key: "3",
            label: (
              // eslint-disable-next-line jsx-a11y/anchor-is-valid
              <a href="#" onClick={odSignOut}>
                {t("employee.label.sign_out")}
              </a>
            ),
            icon: <LoginOutlined />,
          },
        ],
      }}
    >
      <Avatar size={40} src={userAvatar() || undefined} icon={!userAvatar() && <UserOutlined />} />
    </Dropdown>
  );
};

export default User;
